module.exports = __webpack_public_path__ + "img/muzejR.9900b11e.png";